export default __webpack_public_path__ + "static/media/prasheet-pathak.9c2c08ff.jpg";